import { FC } from 'react'
import NotificationButtonList from '../../components/NotificationButtonList/NotificationButtonList'
import { Lead } from '@/api/types/crm.types'
import classes from './index.module.css'
import LeadField from '../../components/LeadField/LeadField'
import { useCRMContext } from '@pages/Admin/CRM/CRMContext'
import useFullLeadModalAccess from '../../hooks/useFullLeadModalAccess'
import { getLeadFieldValue } from '@pages/Admin/CRM/utils/leadFields'

interface WideAboutContentProps {
  lead: Lead
  fieldsData: Record<string, string>
  updateFieldData: (uniqueNameField: string, value: string) => void
}

const WideAboutContent: FC<WideAboutContentProps> = ({
  lead,
  fieldsData,
  updateFieldData,
}) => {
  const {
    preloadingData: { fields: allFields },
  } = useCRMContext()
  const { currentRole, ...access } = useFullLeadModalAccess()
  const optionalTextAreaFields = allFields.filter(
    (field) =>
      field.is_active && !field.is_default && field.type === 'textarea',
  )

  return (
    <div className={classes.listBlock}>
      <div className={classes.listTextAreaFields}>
        {optionalTextAreaFields.map((field) => {
          const defaultValue = getLeadFieldValue(lead, field.unique_name) ?? ''
          const currentValue = fieldsData[field.unique_name] ?? ''

          return (
            <LeadField
              key={field.id}
              field={field}
              value={fieldsData[field.unique_name] ?? ''}
              onChange={(val) => updateFieldData(field.unique_name, val)}
              fieldSettings={{
                phoneNumber: {
                  withIntegrations: access.canInteractWithIntegrations &&
                    lead &&
                    !!defaultValue &&
                    currentValue === defaultValue && {
                      lead,
                      fieldId: field.id,
                      fieldSettings: field.settings,
                    },
                },
              }}
              disabled={!access.canEditFields}
            />
          )
        })}
      </div>
      {access.canControlNotifications && <NotificationButtonList lead={lead} />}
    </div>
  )
}

export default WideAboutContent
